export enum ApiResponseCode {
  SUCCESS = 'SUCCESS_0001',
  UNDER_14 = 'USER_3007',
  NO_EXIST_EVENT = 'RSRC_4001',
  EXPIRED_EVENT = 'RSRC_4004',
  ALREADY_REGISTERED = 'USER_3010',
  NOT_NEW_USER = 'USER_3011',
  NOT_AGREED_TERMS = 'USER_3012',
}
